import { pickerDateToProjectNoonMs, projectDayAsPickerDate } from '../utils/siteTime.js';

/**
 * The issue form's due date follows the date-picker convention: the form holds
 * a zone-naive Date whose LOCAL fields are the site's calendar day; the stored
 * value is an instant. Converting at both ends — on the web dialog and the
 * mobile sheet alike — is what keeps "picked Oct 20" from being stored as the
 * viewer's midnight and shown back as Oct 19 on a site in another zone.
 */

/** Stored instant → the picker Date for the form; null when unset or the
 *  site's zone isn't known yet (the dialog gates Save on the zone). */
export function dueDateForForm(stored: unknown, tz: string | undefined): Date | null {
  if (!tz || (typeof stored !== 'string' && !(stored instanceof Date))) return null;
  return projectDayAsPickerDate(stored, tz);
}

/** Re-anchor a body's picked due date to noon of that day in the site's zone. */
export function withProjectDueDate<T extends { dueDate?: Date | null }>(body: T, tz: string | undefined): T {
  if (!tz || !(body.dueDate instanceof Date)) return body;
  return { ...body, dueDate: new Date(pickerDateToProjectNoonMs(body.dueDate, tz)) };
}
